"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _shared = require("@widget-editor/shared");

var _const = require("../../const");

var _style = require("./style");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Popup = function Popup(_ref) {
  var options = _ref.options,
      getValue = _ref.getValue,
      setValue = _ref.setValue,
      innerRef = _ref.innerRef,
      innerProps = _ref.innerProps,
      selectProps = _ref.selectProps;
  var selected = getValue()[0];
  var _selectProps$align = selectProps.align,
      align = _selectProps$align === void 0 ? _const.ALIGN_HORIZONTAL : _selectProps$align;

  var resolveTitle = function resolveTitle(op) {
    if (op.alias && op.alias.length > 0) {
      return op.alias;
    }

    if (op.name && op.name.length > 0) {
      return op.name;
    }

    return op.identifier;
  };

  return (
    /*#__PURE__*/
    _react["default"].createElement(_style.StyledPopupContainer, _extends({
      align: align,
      ref: innerRef
    }, innerProps),
    /*#__PURE__*/
    _react["default"].createElement(_style.StyledPopupInsideContainer, {
      align: align
    }, options.map(function (op) {
      return (
        /*#__PURE__*/
        _react["default"].createElement(_style.StyledOption, {
          key: op.identifier + op.name,
          nonSelectedCategory: op.identifier === "___single_color",
          active: selected && op.identifier === selected.identifier,
          onClick: function onClick() {
            return setValue(op);
          }
        }, op.identifier !== "___single_color" &&
        /*#__PURE__*/
        _react["default"].createElement(_style.IconBox, null, op.type === "string" ?
        /*#__PURE__*/
        _react["default"].createElement(_shared.CategoryIcon, null) : "#"),
        /*#__PURE__*/
        _react["default"].createElement("p", null, op.identifier === "___single_color" ? "Select column" : resolveTitle(op)), op.description &&
        /*#__PURE__*/
        _react["default"].createElement(_style.StyledDescription, null, op.description))
      );
    })))
  );
};

var _default = Popup;
exports["default"] = _default;